import React from "react";
import { Icon } from "ui";
import ChecklistIcon from "core/icons/checklist/checklist.svg";
import { Container } from "./_taggingStyle";

type OwnProps = {
  number?: number;
  selected?: boolean;
  size?: number;
  isFinished?: boolean;
  onClick?: (...args: any[]) => any;
};

// @ts-expect-error TS(2565): Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof Tagging.defaultProps;

function Tagging(props: Props) {
  const { size, selected, number, isFinished, onClick, ...rest } = props;

  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <Container size={size} onClick={onClick} selected={selected} {...rest}>
      {isFinished && !selected ? <Icon src={ChecklistIcon} /> : `#${number}`}
    </Container>
  );
}

Tagging.defaultProps = {
  number: 1,
  selected: false,
  size: 32,
  isFinished: false,
  onClick: () => {},
};

export default Tagging;
